var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.computedSourceOfCuration !== 'data_portal_api')?_c('Tooltip',{staticClass:"customlink inline",attrs:{"direction":"top","contents":`Source of curation: ${_vm.computedSourceOfCuration}`}},[_c('IconBookOpen',{attrs:{"size":"md"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }